import { render, staticRenderFns } from "./Crisis_Intervent_Committee.vue?vue&type=template&id=157d759c"
import script from "./Crisis_Intervent_Committee.vue?vue&type=script&lang=js"
export * from "./Crisis_Intervent_Committee.vue?vue&type=script&lang=js"
import style0 from "./Crisis_Intervent_Committee.vue?vue&type=style&index=0&id=157d759c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports